import gql from 'graphql-tag';

export const getOneEvidence = gql`
  query Evidence($id: ID!) {
    data: Evidence(id: $id) {
      id
      name
      type
      status
      content
      pdf{
        url,
        fileName
      }
      uploadChoice
      videoEvidenceLoop
      plotId {
        id
        name
        status
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
